import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { DisplayCarrierDriverComponent } from "./display-carrier-driver.component";
import { BusyModule } from "app/busy/busy.module";
import { CarrierDriverDetailsModule } from "../carrier-driver-details/carrier-driver-details.module";

@NgModule({
  declarations: [DisplayCarrierDriverComponent],
  imports: [CommonModule,CarrierDriverDetailsModule,],
  exports: [DisplayCarrierDriverComponent],
})
export class DisplayCarrierDriverModule {}
